import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit {
  constructor(private router: Router, private route: ActivatedRoute) {
    /** empty block */
  }

  public ngOnInit() {
    const nextUrl = this.route.snapshot.queryParams.nextUrl;
    // tslint:disable-next-line:no-unused-expression
    nextUrl && this.router.navigate([nextUrl]);
  }
}
